<template>
  <div>
    <AppButton color="blue" @click="openConversationsModal">
      Meddelanden
      <template #append>
        <SvgIcon :path="mdiMessageAlertOutline" size="16" />
      </template>
      <template #badge>
        <AppNotificationBadge :count="conversationsController.unreadCount.value" />
      </template>
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { mdiMessageAlertOutline } from '@mdi/js'
import { AppButton, AppNotificationBadge, SvgIcon, useConversationsController, useModal } from '@staff/ui'
import MicroscopeConversations from './MicroscopeConversations.vue'
import { useMicroscopeConversations } from '@/composables/useMicroscopeConversations'

const props = withDefaults(
  defineProps<{
    applicationId?: string
    debtId?: string
  }>(),
  {
    applicationId: undefined,
    debtId: undefined,
  },
)

const conversationsApi = useMicroscopeConversations()
const conversationsTarget = computed(() =>
  props.applicationId
    ? {
        kind: 'application' as const,
        id: props.applicationId,
      }
    : {
        kind: 'debt' as const,
        id: props.debtId ?? '',
      },
)
const conversationsController = useConversationsController(conversationsApi, () => conversationsTarget.value)
const { openModal } = useModal()

const openConversationsModal = () => {
  openModal(
    'Meddelanden',
    MicroscopeConversations,
    {
      controller: conversationsController,
    },
    { size: 'large' },
  )
}

onMounted(async () => {
  await conversationsController.refresh()
})
</script>
